// TagService.js
import axios from "axios";
import { API_BASE_URL } from "../../../../../../../../../../Helpers/apiConfig";

const BASE_URL = `${API_BASE_URL}/admin/TagManager`;

export const getActiveTags = async (token) => {
    try {
        const response = await axios({
            method: 'GET',
            url: `${BASE_URL}/GetTags`,
            headers: {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });

        if (response.status === 200 && response.data.success) {
            // Sadece silinmemiş etiketleri filtreleyip döndürüyoruz
            return response.data.data
                .filter(tag => !tag.isDeleted)
                .map(tag => ({
                    id: tag.id,
                    tagName: tag.tagName
                }));
        } else {
            throw new Error(response.data.message || "Etiketler alınamadı.");
        }
    } catch (error) {
        throw error;
    }
};